import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Reveal from "./reveal"
import Img from "gatsby-image"

export default function Vidtestimonials() {
  const data = useStaticQuery(graphql`
    query TimImageQuery {
      prismicHomepage {
        
        data {
          testimonial_title {
            text
          }
          timimage {
            fluid {
              ...GatsbyPrismicImageFluid_noBase64
            }
          }
        }
      }
    }
  `)
  const timImage = data.prismicHomepage.data["timimage"].fluid
  const title = data.prismicHomepage.data["testimonial_title"].text
  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="max-w-xs md:max-w-md text-center text-4xl md:text-5xl mx-auto font-bold mt-8 mb-12 md:mb-14 lg:mb-24">
        {title}
      </h1>
      <Reveal
        className="mx-auto mb-4 md:mb-14 flex flex-col lg:flex-row justify-between items-center px-2 md:px-12"
        once={true}
        y={0}
        dur={0.6}
        threshold={0.5}
      >
        <div className="order-2 px-4 md:px-0">
          <p className="text-blue-dark text-xl leading-6 font-light max-w-sm mx-auto md:mb-4 mb-2">
            "Bankjoy offers a very stable product that is easy to use, easy to
            navigate and is very user-friendly. Our members love Bankjoy."
          </p>
          <div className="flex items-center">
            <Img fluid={timImage} className="w-12 h-12 rounded-full mr-2"/>
            <div>
              <div className="font-medium text-blue-dark text-sm">Tim Miller</div>
              <div className="text-blue-dark text-xs">
                CEO at Cooperative Teachers <br />
                Credit Union
              </div>
            </div>
          </div>
        </div>
        <div className="lg:mr-10 lg:px-0 px-4">
          <video
            preload="none"
            className="mx-auto rounded-md lg:mb-0 mb-6"
            controls
            src="https://prismic-io.s3.amazonaws.com/bankjoyweb/7845c8c1-4e1c-44a5-b97e-726bca13306e_Timmiller_comp.mp4"
            playsInline
            poster="https://images.prismic.io/bankjoyweb/cfe0b1cc-96d1-438d-aa58-e8ec16226f38_Screen+Shot+2021-06-10+at+23.18.12.png?auto=compress,format"
          ></video>
        </div>
      </Reveal>
    </div>
  )
}
